// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"RW-z","sponsoredTooltipWrapper":"SW-z","sponsoredTooltip":"TW-z","newCard":"UW-z"};